import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/data";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026">
      <p className="text-white/60 font-light leading-relaxed text-[15px]">
        This Privacy Policy explains how <strong className="text-white">{COMPANY.legalName}</strong> ("Auto-Hire STL,"
        "we," "us," or "our") collects, uses, and protects your information when you visit our website, submit a
        booking or contact request, or rent a vehicle from us.
      </p>

      <LegalSection heading="1. Information We Collect">
        <p>We collect information you provide directly to us, including your name, email address, phone number,
        requested vehicle, and pickup and return dates when you submit a booking or contact form. When you rent a
        vehicle, we may also collect driver's license, insurance, and payment information.</p>
      </LegalSection>

      <LegalSection heading="2. How We Use Your Information">
        <p>We use your information to: respond to and fulfill your booking and contact requests; send you
        transactional confirmations and updates by SMS and email; process rentals and payments; provide customer
        support; and comply with legal obligations.</p>
      </LegalSection>

      <LegalSection heading="3. SMS & Email Communications">
        <p>By providing your phone number and email and submitting a request, you consent to receive
        booking-related text messages and emails from us. Message and data rates may apply. You can opt out of
        non-essential communications at any time by replying STOP to a text or contacting us directly.</p>
      </LegalSection>

      <LegalSection heading="4. Sharing of Information">
        <p>We do not sell your personal information. We may share information with trusted service providers who
        help us operate our business — such as our customer-relationship and messaging platform (GoHighLevel) and
        our email provider (Resend) — solely to deliver the services you request. These providers are bound to
        protect your information.</p>
      </LegalSection>

      <LegalSection heading="5. Data Retention">
        <p>We retain your information for as long as necessary to provide our services, fulfill rentals, comply
        with our legal obligations, resolve disputes, and enforce our agreements.</p>
      </LegalSection>

      <LegalSection heading="6. Data Security">
        <p>We use reasonable administrative, technical, and physical safeguards to protect your information.
        However, no method of transmission over the internet is completely secure, and we cannot guarantee
        absolute security.</p>
      </LegalSection>

      <LegalSection heading="7. Your Rights">
        <p>You may request access to, correction of, or deletion of your personal information by contacting us
        using the details below. We will respond in accordance with applicable law.</p>
      </LegalSection>

      <LegalSection heading="8. Cookies & Analytics">
        <p>Our website may use cookies and similar technologies to operate the site and understand usage. You can
        control cookies through your browser settings.</p>
      </LegalSection>

      <LegalSection heading="9. Children's Privacy">
        <p>Our services are not directed to individuals under 18, and we do not knowingly collect personal
        information from children.</p>
      </LegalSection>

      <LegalSection heading="10. Changes to This Policy">
        <p>We may update this Privacy Policy from time to time. The "Last updated" date above reflects the most
        recent revision.</p>
      </LegalSection>

      <LegalSection heading="11. Contact Us">
        <p>{COMPANY.legalName}<br />
        {COMPANY.address}<br />
        Phone: <a href={COMPANY.phoneHref} className="text-[#F2B705]">{COMPANY.phone}</a><br />
        Email: <a href={`mailto:${COMPANY.email}`} className="text-[#F2B705]">{COMPANY.email}</a></p>
      </LegalSection>
    </LegalLayout>
  );
}
